import { render, staticRenderFns } from "./Dialer.vue?vue&type=template&id=1a224448&scoped=true&"
import script from "./Dialer.vue?vue&type=script&lang=js&"
export * from "./Dialer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a224448",
  null
  
)

export default component.exports